/**
 * Helper para determinar el origen de registro del usuario.
 * 
 * Lógica:
 *  1. Si el usuario está en /summer-edition → siempre "summer"
 *  2. Si hay ?ref= en la URL → usa ese valor
 *  3. Fallback por fecha: junio (6) a agosto (8) → "summer", resto → "liga"
 */

/**
 * Determina si estamos en temporada Summer por fecha.
 * Junio = mes 5, Julio = mes 6, Agosto = mes 7 (0-indexed)
 * @returns {boolean}
 */
export const isSummerSeason = () => {
  const mes = new Date().getMonth();
  return mes >= 5 && mes <= 7; // junio, julio, agosto
};

/**
 * Devuelve el ref de registro basado en la temporada actual.
 * @returns {'summer' | 'liga'}
 */
export const getRegistroRef = () => {
  return isSummerSeason() ? 'summer' : 'liga';
};

/**
 * Construye la URL de registro con el ref adecuado.
 * @param {string} [overrideRef] - Forzar un ref específico (ej: desde /summer-edition)
 * @returns {string} URL tipo "/register?ref=summer"
 */
export const getRegisterUrl = (overrideRef) => {
  const ref = overrideRef || getRegistroRef();
  return `/register?ref=${ref}`;
};
